import { render } from "./calendar-list-event.vue?vue&type=template&id=2814968a"
import script from "./calendar-list-event.vue?vue&type=script&lang=js"
export * from "./calendar-list-event.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__